export class TuwaiqConfig {
    public static REQUEST_QUERY_PARAMS = {
        PAGE: 'page',
        SIZE: 'size',
        STATUS_FILTER: 'filter[status-id]',
        REQUESTER_FILTER: 'filter[requester-id]',
        CLIENTS_FILTER: 'filter[client-ids]',
        CLIENT_FILTER: 'filter[client-id]',
        SERVICE_FILTER: 'filter[service-ids]',
        PENDING_WITH_FILTER: 'filter[pending-with-id]',
        COMPLETED_BY_FILTER: 'filter[completed-by-id]',
        CREATION_START_DATE_FILTER: 'filter[creation-date-start]',
        CREATION_END_DATE_FILTER: 'filter[creation-date-end]',
        ROLE_NAME_FILTER: 'filter[role-name]',
        ROLE_STATUS_FILTER: 'filter[status]',
        SEARCH_QUERY: '_q',
        SEARCH_KEYWORD: 'keyword',
        INCLUDE: 'include',
        SORT_BY: 'sort-by',
        ORDER_BY: 'order-by',
        STATUS: 'status',
        SECTION_ID: 'section-id',
        SECTION_FILTER: 'filter[section-id]',
        EXCLUDE_ROLE_NAME: 'filter[exclude-role-name]',
        REQUEST_TYPE: 'filter[request-types]',
        SENDER_IDS: 'filter[sender-ids]',
        DEPARTMENT_IDS: 'filter[department-ids]',
        DEPARTMENT_ID: 'filter[department-id]',
        SECTION_IDS: 'filter[section-ids]',
        MAIN_TYPE_ID_FILTER: 'filter[main-ticket-type-ids]',
        SUB_TYPE_ID_FILTER: 'filter[sub-ticket-type-ids]',
        REQUESTER_ID_FILTER: 'filter[requester-ids]',
        TICKET_STATUS_ID_FILTER: 'filter[ticket-status-ids]',
        PRIORITIES_ID_FILTER: 'filter[priorities]',
        ASSIGNED_TO_ME_FILTER: 'filter[assigned-to-me]',
        SERVICES_MANAGEMENT: 'filter[services-management]',
        REQUESTER_BY_ME: 'requested-by-me',
        NEED_MY_APPROVAL: 'need-my-approval',
        TEAM_SERVICES: 'team-services',
        REPORT_TYPE_IDS: 'filter[report-type-ids]',
        REPORT_AUDIT_TYPE: 'filter[audit-type-ids]',
        REPORT_STATUS_IDS: 'filter[statuses]',
        REPORT_CREATOR_IDS: 'filter[creator-ids]',
        REPORT_STAKEHOLDERS_IDS: 'filter[stakeholder-id]',
        REPORT_ATTACHMENT_USER: 'attachment-user',
        REPORT_SHOW_ALL_SECTIONS: 'showAllSectionsReports',
        REPORT_RETURN_START_DATE_FILTER: 'filter[return-start-date]',
        REPORT_RETURN_END_DATE_FILTER: 'filter[return-end-date]',
        REPORT_DEVICE_NAME: 'filter[device-name]',
        REPORT_OWNER: 'filter[owner]',
        REPORT_EDITOR: 'filter[editor-ids]',
        REPORT_CHANGE_RESOURCE: 'filter[change-source]',
        REPORT_FIELD_NAME: 'filter[field-names]',
        REPORT_EDIT_START_DATE: 'filter[edit-start-date]',
        REPORT_EDIT_END_DATE: 'filter[edit-end-date]',
        EMPLOYEE_IDS: 'filter[employee-ids]',
        CALL_RECORD_SMS: 'sms',
        ACTIONS_FILTER: 'action',
        ACTIVE: 'active',
        SECTION_FOR_IC: 'ic',
        PERMISSION_TYPE: 'filter[permission-type]',
        IS_GM: 'gm-team',
        IS_DELEGATE: 'delegate'
    };

    public static REQUEST_INCLUDES = {
        PENDING_WITH: 'pendingWith',
        CREATOR: 'creator',
        USERS_COUNT: 'usersCount',
        ASSIGNED_REQUEST_COUNT: 'assignedRequestsCount',
        AVAILABLE: 'AVAILABLE',
        UNAVAILABLE: 'UNAVAILABLE'
    };

    public static REQUEST_LIST_SORT_BY = {
        CREATION_DATE: 'creationDate',
        RETURN_DATE: 'returnedDate'
    };

    public static REQUEST_LIST_ORDER = {
        DESC: 'desc',
        ASC: 'asc'
    };

    public static PAGINATION_CONFIG = {
        DEFAULT_PAGE_NUMBER: 1,
        STORAGE_DEFAULT_PAGE_NUMBER: 0,
        DEFAULT_PAGE_SIZE: 20,
        DASHBOARD_DEFAULT_PAGE_SIZE: 15,
        EMPLOYEE_SEARCH_DEFAULT_PAGE_SIZE: 50,
        SERVICECATALOG_PAGE_SIZE: 24,
        DEFAULT_PAGE_SIZE_TICKETING_MODULE: 12,
        DEFAULT_PAGE_SIZE_PERIODIC_REVIEW: 12,
        DEFAULT_PAGE_SIZE_ESERVICES_CLIENT: 12,
        DEFAULT_PAGE_SIZE_STORAGE_UNIT: 6,
        DEFAULT_PAGE_SIZE_MESSAGE_CENTER: 16,
        DEFAULT_PAGE_SIZE_Employees_List: 12
    };

    public static REQUEST_STATUS: { [key: string]: number } = {
        OPEN: 1,
        INPROGESS: 2,
        RETURNED: 3,
        CLOSED: 4
    };

    public static IMAGES_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png'];
    public static EMAILS_ALLOWED_EXTENSIONS = ['eml', 'msg', 'pst', 'ost', 'mbox', 'dbx', 'nsf'];
    public static ATTACHMENTS_EXCLUDED_EXTENSIONS = ['zip', 'rar', 'jar', 'exe', 'dll', 'iso', 'dmg', 'svg'];
    public static FILES_EXCLUDED_EXTENSIONS = ['xlsx', 'ppt', 'pptx', 'pdf', 'doc', 'docx', 'txt'];

    public static ATTACHMENTS_ALLOWED_EXTENSIONS = [
        ...TuwaiqConfig.IMAGES_ALLOWED_EXTENSIONS,
        ...TuwaiqConfig.EMAILS_ALLOWED_EXTENSIONS,
        ...TuwaiqConfig.FILES_EXCLUDED_EXTENSIONS
    ];

    public static MAX_IMAGE_SIZE = 1024 * 1024 * 5; //5 MB
    public static MAX_ATTACHMENT_SIZE = 1024 * 1024 * 15; //15 MB
    public static MAX_ATTACHMENT_UPLOAD_NUMBER = 15;
    public static ATTACHMENT_CHECKSUM = 'zM/VLDNWkz816tz9xiWkPQ==';

    public static LANG = {
        EN: 'en',
        AR: 'ar'
    };

    public static REQUEST_FIELDS_MAX_LENGTH = {
        createRequestDesc: 2000,
        processRequestReply: 1000,
        returnRequestComment: 1000,
        addAndEditServiceSystemClientName: 50,
        siteLength: 40
    };

    // NOTE: key must match VIEW_TYPE value
    public static REQUESTS_COUNT_KEYS: { [key: string]: string } = {
        NEW: 'openedRequests',
        RETURNED: 'returnedRequests',
        ASSIGNED: 'assignedRequests',
        INPROGRESS: 'inProgressRequests',
        COMPLETED: 'closedRequests',
        EMPLOYEEMANAGEMENTREQUESTS: 'admissionRequests',
        SECURITYCOORDINATORREQUESTS: 'admissionRequests',
        COMPLETEDHISTORYREQUESTS: 'operationHistoryRequests',
        TECHNICALOPERATIONSREQUESTS: 'operationPendingRequests',
        CALL_RECORD: 'callRecord'
    };

    public static CREATE_REQUEST_KEYS = {
        ATTACHMENTS: 'attachments',
        DESCRIPTION: 'description',
        DETAILS: 'details',
        SERVICE_ID: 'service-id'
    };
    public static NUMBER_FIELD_EService_MAX_LENGTH = {
        defalut: 20,
        amount: 20,
        id: 10,
        portNumber: 16,
        requestId: 10,
        serialNumber: 20,
        serviceNumber: 20,
        srNumber: 20
    };
}
